import React from 'react'
import MainLayout from '../../../components/MainLayout'
import FormatoDePerfil from './components/FormatoDePerfil'

const CrearAgente = () => {
  return (
    <MainLayout>
    <div className="row title_layout">
      <div className="col-6">
        <h5>CREAR PERFIL DE AGENTE ADUANAL</h5>
      </div>
    </div>
    <FormatoDePerfil />
  </MainLayout>
  )
}

export default CrearAgente